if (!customElements.get("s-account-orders")) {
  customElements.define(
    "s-account-orders",
    class AccountOrders extends HTMLElement {
      constructor() {
        super();

        // object with dates in milliseconds
        this.filterTimeObject = {
          last_day: "86400000",
          last_week: "604800000",
          last_month: "2678400000",
          three_month: "8035200000",
          six_month: "16070400000",
        };
      }

      connectedCallback() {
        this.ordersList = this.querySelector(".js-account-orders__list");
        this.ordersMobileList = this.querySelector(".js-account-orders__list-mobile");
        this.btnShowAll = this.querySelector(".js-account-orders__filter-all");
        this.optionShowAll = this.querySelector(
          ".js-account-orders__filter-date--item--show-all"
        );
        this.selectedDateTitle = this.querySelector(
          ".js-account-orders__filter--text"
        );
        this.filterDateElement = this.querySelector(
          ".js-account-orders__filter"
        );
        this.datesContainer = this.querySelector(
          ".js-account-orders__filter-date"
        );
        this.dropdownArrow = this.querySelector('.js-account-orders__filter--arrow');

        this.filterDateElement.addEventListener("click", this.handleClick);
        this.btnShowAll.addEventListener("click", this.toggleOrdersVisibility);
      }

      disconnectedCallback() {
        this.filterDateElement.removeEventListener("click", this.handleClick);
        this.btnShowAll.removeEventListener("click", this.toggleOrdersVisibility);
      }

      handleSelectDate = (target) => {
        const time = target.dataset.time;
        const title = target.innerText;
        const dateNow = new Date();

        let checkDate = time
          ? new Date(+dateNow - +this.filterTimeObject[time])
          : new Date(0);

        this.toggleOrdersVisibility(checkDate, title);
      }

      toggleOrdersVisibility = (checkDate = new Date(0), title = this.optionShowAll.innerText) => {
        this.selectedDateTitle.innerText = title.trim();

        const orders = [...this.ordersList.children];
        const ordersMobile = [...this.ordersMobileList.children]

        orders.forEach((el, index) => {
          //  skips first line because its titles line
          if (index === 0) {
            return;
          }
          const created = el.dataset.created;
          const createdDate = new Date(created);

          // hides orders that not out of selected date and show them othervise
          if (+checkDate - +createdDate > 0) {
            el.style.display = "none";
          } else {
            el.style.display = "grid";
          }
        });

        ordersMobile.forEach((el, index) => {
          //  skips first line because its titles line
          if (index === 0) {
            return;
          }
          const created = el.dataset.created;
          const createdDate = new Date(created);

          // hides orders that not out of selected date and show them othervise
          if (+checkDate - +createdDate > 0) {
            el.style.display = "none";
          } else {
            el.style.display = "flex";
          }
        });
      }

      handleClick = (event) => {

        if (event.target.closest(".s-account-orders__filter-date--item")) {
          this.handleSelectDate(event.target);
          this.closeSelect();
        } else if (event.target.closest(".js-account-orders__filter") && this.filterDateElement.classList.contains('s-account-orders__filter--active')) {
          this.closeSelect();
        } else if (event.target.closest(".js-account-orders__filter")) {
          this.openSelect();
        }
      }

      openSelect = () => {
        this.filterDateElement.classList.add(
          "s-account-orders__filter--active"
        );
        this.dropdownArrow.classList.add('s-account-orders__filter--arrow-active');
        window.addEventListener("mouseup", this.handleMouseUp);
      }

      handleMouseUp = () => {
        if (!this.filterDateElement.contains(event.target)) {
          this.closeSelect();
        }
      }

      closeSelect = () => {
        this.filterDateElement.classList.remove(
          "s-account-orders__filter--active"
        );
        this.dropdownArrow.classList.remove('s-account-orders__filter--arrow-active');
      }
    }
  );
}